
import axios from "axios";
import { createContext, useContext, useState } from "react";
import { UserContext } from "./UserContext.js";
import { toast } from "react-toastify";


export let CompanyContext = createContext();


export default function CompanyContextProvider(props){

   const [company , setCompany] = useState([]);
   const [allCompanyInfo , setAllCompanyInfo] = useState([]);
   const [testCount , setTestCount] = useState(0) ;
   const {userToken } = useContext(UserContext) ;


   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }

   //& Get Specific Company :
   async function getCompany(id){
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/company/${id}` , {headers:header})
      .then(({data})=>{
         if(data.message === "success"){
            setCompany(data.company)
            setTestCount(data.test_Count)
         }
      })
      .catch((error)=>{
         toast.error(error.response?.data.message)
      })
   }



   //& Get All  Company Information :
   async function getAllCompanyInfo(){
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/company` , {headers:header})
      .then(({data})=>{
         if(data.message === "success"){
            setAllCompanyInfo(data?.companies)
         }
      })
      .catch((error)=>{
         toast.error(error.response.data.message)
      })
   }


   return (
      <>
         <CompanyContext.Provider value={{company , setCompany , getCompany , testCount , allCompanyInfo , setAllCompanyInfo , getAllCompanyInfo}}>
            {props.children}
         </CompanyContext.Provider>
      </>
   )
}